// Handle when the menu button is clicked
function handleMobileMenuClick(e) {
	const body = document.querySelector('body');
	const mobileMenu = document.querySelector('.nav-mobile-menu');
	const header = document.querySelector(".headroom")

	const transparentHeader = header.classList.contains("index") ? true : false

	if (e.classList.contains('close')) {
		e.classList.remove('close');
		mobileMenu.classList.remove('open');
		body.classList.remove('prevent-scroll');

		if (transparentHeader) {
			header.classList.add("transparent")
		}
	} else {
		e.classList.add('close');
		mobileMenu.classList.add('open');
		body.classList.add('prevent-scroll');

		if (transparentHeader) {
			header.classList.remove("transparent")
		}
	}
}

// Handle when the search button is clicked
function handleSearchButtonClick(e) {
	const searchFlyout = document.querySelector('.search-flyout');

	const transparentHeader = header.classList.contains("index") ? true : false

	if (searchFlyout) {
		if (e.classList.contains('active')) {
			e.classList.remove('active');
			searchFlyout.classList.remove('active');
			if (transparentHeader) {
				header.classList.add("transparent")
			}
		} else {
			e.classList.add('active');
			searchFlyout.classList.add('active');
			if (transparentHeader) {
				header.classList.remove("transparent")
			}
		}
	}
}

// Handle Sub nav click for mobile menu
function handleMobileSubNavClick(e) {
	const accordionPanel = e.nextElementSibling;
	const accordionContent = accordionPanel.querySelector('.accordion-panel__content');
	const accordionHeight = accordionPanel.querySelector('.accordion-panel__content-body').getBoundingClientRect().height;
	const subMenu = accordionPanel.querySelector('.nav-sub-menu');

	if (e.classList.contains('expanded')) {
		e.classList.remove('expanded');
		e.setAttribute('aria-expanded', false);
		accordionContent.style.maxHeight = `0px`;
		subMenu.classList.remove('active');
	} else {
		e.classList.add('expanded');
		e.setAttribute('aria-expanded', true);
		accordionContent.style.maxHeight = `${accordionHeight}px`;
		subMenu.classList.add('active');
	}
}

// On content loaded
document.addEventListener("DOMContentLoaded", () => {
	const menuWithSubmenu = document.querySelectorAll('.nav-control.with-submenu');
	const subMenuContainer = document.querySelector('.navigation__menu-container');
	const subMenus = document.querySelectorAll('.nav-sub-menu');
	const header = document.querySelector(".headroom")

	let activeSubMenuIndex = 0;

	// Show active submenu
	function activateMenu(menu) {
		activeSubMenuIndex = menu.dataset.index;
		const subMenu = document.querySelector(`.nav-sub-menu[data-index="${activeSubMenuIndex}"`);
		const subMenuHeight = subMenu.getBoundingClientRect().height
		subMenuContainer.classList.add('open');
		subMenu.classList.add('active');
		subMenuContainer.style.height = `${subMenuHeight}px`;

		header.classList.remove("transparent")
	}

	// Hide sub menus
	function deactivateMenu() {
		const subMenu = document.querySelector(`.nav-sub-menu[data-index="${activeSubMenuIndex}"`);

		subMenuContainer.classList.remove('open');
		subMenu.classList.remove('active');
		activeSubMenuIndex = 0;
		subMenuContainer.style.height = `0px`;

		header.classList.add("transparent")
	}

	// Loop through menus with sub menu and add mouse enter/leave events
	[...menuWithSubmenu].forEach(menu => {
		menu.addEventListener('mouseenter', e => {
			activateMenu(menu);
		});

		menu.addEventListener('mouseleave', e => {
			deactivateMenu();
		});
	});

	// Loop through sub menus and add mouse enter/leave events
	[...subMenus].forEach(menu => {
		menu.addEventListener('mouseenter', e => {
			activateMenu(menu);
		});

		menu.addEventListener('mouseleave', e => {
			deactivateMenu();
		});
	});

	// On desktop search handle submit (handleSearch() is in liquid file for liquid variable)
	// document.querySelector('.search-flyout__form').addEventListener('submit', (event) => {
	// 	event.preventDefault();
	// 	handleSearch(event.target.elements[1].value);
	// });

	// On mobile search handle submit (handleSearch() is in liquid file for liquid variable)
	document.querySelector('.nav-mobile-menu__search').addEventListener('submit', (event) => {
		event.preventDefault();
		handleSearch(event.target.elements[0].value);
	});
});